import React, {useEffect, useState} from "react";
import TextareaAutosize from "react-textarea-autosize";
import styles from "./index.module.scss";

const TextInput = ({name, value, textOnChange, placeholder}) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (value) {
      setInputValue(value);
    } else {
      setInputValue("");
    }
  }, [value]);

  const handleInputChange = e => {
    setInputValue(e.target.value);
    textOnChange(e);
  };

  return (
    <>
      {name === "Title" ? (
        <div className={styles.inputTitle}>
          <TextareaAutosize spellCheck={false} name={name} value={inputValue} onChange={handleInputChange} placeholder={placeholder} />
        </div>
      ) : (
        <div className={styles.input}>
          <div className={styles.name}>{name}</div>
          <TextareaAutosize spellCheck={false} name={name} value={inputValue} onChange={handleInputChange} placeholder={placeholder} />
        </div>
      )}
    </>
  );
};

export default TextInput;
